import { useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'react-hook-form'

export const useSetDefaultQuantity = (setValue: UseFormSetValue<FieldValues>) => {
	useEffect(() => {
		setValue('quantity', 1)
	}, [])
}
